import { useCallback } from "react";

interface ToastOptions {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

export function useToast() {
  const toast = useCallback(
    ({ title, description, variant = "default" }: ToastOptions) => {
      // For now, just log to console since we don't have a toast component yet
      console.log(
        `[${variant.toUpperCase()}] ${title || "Notification"}: ${
          description || ""
        }`
      );
    },
    []
  );

  // Add convenience methods
  const success = useCallback(
    (message: string) => {
      toast({ title: "Succes", description: message, variant: "default" });
    },
    [toast]
  );

  const error = useCallback(
    (message: string) => {
      toast({ title: "Eroare", description: message, variant: "destructive" });
    },
    [toast]
  );

  return {
    toast: Object.assign(toast, { success, error }),
  };
}
